
import { requestSubscription } from 'constants/newsLetter';
import React, { useState } from 'react';

const FooterNewsLetter = ({size}) => {

    const SUCCESS_TEXT = 'Email has been sent. Please check'
    const FAIL_TEXT = "Something went wrong Try again"
    const [email , setEmail] = useState('')
    const [bottomText , setBottomText] = useState('<strong>NOTE:</strong> By entering your email ID, you authorise <a href = "/">thelallantop.com</a> to send newsletters to your email.')
    const [isError , setIsError] = useState(false)
    const [subscribeLoading , setSubscribeLoading] = useState(false)
  
    const handleSubscribeClick = () => {
        setSubscribeLoading(true)
        requestSubscription(email).then(res => {
            setBottomText(SUCCESS_TEXT)
            setSubscribeLoading(false)
            setIsError(false)
        }).catch(err => {
            setBottomText(err?.data  ? err?.data : FAIL_TEXT)
            setSubscribeLoading(false)
            setIsError(true)
        })
    }
    
    const containerStyle = {
        display: 'flex',
        backgroundColor: '#F8F0E3',
        borderRadius: '8px',
        width: '328px',
        alignItems: 'center',
    };

    const inputStyle = {
        border: 'none',
        outline: 'none',
        padding: '0px 15px',
        backgroundColor: '#F8F0E3',
        fontSize: '14px',
        fontWeight: "40",
        color: '#333',
    };

    const buttonStyle = {
        backgroundColor: '#FFC609',
        border: 'none',
        padding: '10px 20px',
        fontWeight: '400',
        borderRadius: '8px',
        color: '#000',
        cursor: 'pointer',
        fontSize: "12px",
        minWidth : "94px"

    };
    return (
        size?.width > 700  ?
            <div className='container my-2 ' style={{ height: "164px", backgroundColor: "#FBF8F1", borderRadius: "10px" }}>
                <div className='d-flex align-items-center justify-content-center' style={{ gap: "10%" }}>
                    <div>
                        <p className='m-0 p-0' style={{ fontFamily: "Mukta,system-ui, -apple-system, BlinkMacSystemFont", fontWeight: 900, fontSize: "25px" }}>Subscribe </p>
                        <p className='m-0 p-0' style={{ fontFamily: "Mukta,system-ui, -apple-system, BlinkMacSystemFont", fontWeight: 900, fontSize: "25px" }}> to Our Newsletter</p>
                    </div>
                    <div style={containerStyle} className="shadow-sm">
                        <input
                            value={email}
                            onChange={(event) => setEmail(event.target.value)}
                            type="email"
                            placeholder="Enter Your Email"
                            style={inputStyle}
                            className="form-control-plaintext"
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  handleSubscribeClick();
                                }
                              }}
                        />
                        <button onClick={handleSubscribeClick} style={buttonStyle} className="ms-2">
                        {subscribeLoading ? '...'   :'SUBSCRIBE'}
                        </button>
                    </div>
                    <div style={{ width: "147px", height: "130px" }} >
                        <img className='w-100 h-100' src="./assets/images/news_letter.png"></img>
                    </div>

                </div>
                <p className='m-0 p-0 text-end me-5 mt-3' dangerouslySetInnerHTML={{ __html: bottomText }} style={{ fontWeight: isError ?600 : 200, fontSize: isError ? "13px" : "9px",  color : isError ? "red"   : "#333" }}/>
                    {/* {bottomText}
                    </p> */}
            </div>
            : <div className='container my-2 ' style={{ backgroundColor: "#FBF8F1", borderRadius: "10px" }}>

                <div className='d-flex align-items-center justify-content-center' style={{ gap: "10%" }}>
                    <div>
                        <p className='m-0 p-0' style={{ fontFamily: "Mukta,system-ui, -apple-system, BlinkMacSystemFont", fontWeight: 900, fontSize: "25px" }}>Subscribe </p>
                        <p className='m-0 p-0' style={{ fontFamily: "Mukta,system-ui, -apple-system, BlinkMacSystemFont", fontWeight: 900, fontSize: "25px" }}> to our Newsletter</p>
                    </div>

                    <div style={{ width: "70px", height: "79px" }} >
                        <img className='w-100 h-100' src="./assets/images/news_letter.png"></img>
                    </div>

                </div>
                <div style={containerStyle} className="shadow-sm mx-auto my-4">
                    <input
                        value={email}
                        onChange={(event) => setEmail(event.target.value)}
                        type="email"
                        placeholder="Enter Your Email"
                        style={inputStyle}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              handleSubscribeClick();
                            }
                          }}
                        className="form-control-plaintext"
                    />
                    <button onClick={handleSubscribeClick} style={buttonStyle} className="ms-2">
                        {subscribeLoading ? '...'   :'SUBSCRIBE'}
                    </button>
                </div>
                <p className='m-0 p-0 text-center' dangerouslySetInnerHTML={{ __html: bottomText }} style={{ fontWeight: isError ?600 : 200, fontSize: isError ? "13px" : "9px",  color : isError ? "red"   : "#333" }}/>
                    {/* {bottomText}</p> */}
            </div>

    )
}

export default FooterNewsLetter